export default {
  STATUS: {
    RED: "RED",
    AMBER: "AMBER",
    GREEN: "GREEN",
    UNKNOWN: "UNKNOWN",
  }    
};